import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQItemm from './FAQItemm';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Morachichincholihomestay() {



    const cardData =
    {
        keyword: 'Morachi Chincholi Home Stay',
        heading: 'Anand Krushi Paryatan Kendra: Morachi Chincholi Home Stay',
        headingDescription: 'Experience authentic village life with a charming Morachi Chincholi home stay at Anand Krushi Paryatan Kendra, located just 55 km from Pune. Nestled within a 40-acre agri-tourism property, this idyllic retreat offers comfortable rural-style accommodations that immerse you in the sights and sounds of the countryside. Enjoy a full-day (and optional overnight) getaway with activities such as bullock cart and tractor rides, horse riding, boating, swimming, rain dance, puppet and magic shows, and traditional village games. Ideal for families, school groups, or anyone seeking a peaceful escape, the Morachi Chincholi home stay lets you wake up to the gentle cooing of peacocks, lush green surroundings, and the inviting aroma of homemade Maharashtrian meals.',

        top: 'Top Activities at Anand Krushi Paryatan Kendra:',

topPlaces: [
  {
    "title": "Cozy Village Cottage Stay",
    "description": "Stay in charming, rustic cottages surrounded by greenery—complete with cozy beds, attached bathrooms, and traditional décor. Experience the comfort of a home‑stay with modern amenities, all nestled within farm landscapes."
  },
  {
    "title": "Authentic Wood‑Fire Meals",
    "description": "Wake up to homemade breakfast—poha, upma, misal‑pav—cooked on a wood-fired chulha. Dinner features freshly prepared seasonal dishes like puranpoli, dal‑rice, and bhakri, served family‑style under starry skies."
  },
  {
    "title": "Tranquil Rural Ambience",
    "description": "Enjoy the calm of village life—morning chants, chirping birds, and peacocks dancing in the fields—away from city noise. Early walks are a visual delight for nature and bird lovers."
  },
  {
    "title": "Farm‑to‑Table Farming Tours",
    "description": "Join guided farming tours right from your doorstep—see vegetable plots, fruit orchards, dairy units, and learn about organic practices. Pick your own produce for a fresh farm‑to‑plate experience."
  },
  {
    "title": "Interactive Animal & Dairy Farm",
    "description": "Spend time at the petting farm—milking cows, feeding calves, visiting goats and hens. Kids particularly love watching buffaloes bathe and helping with simple farm chores."
  },
  {
    "title": "Evening Campfire & Folk Evenings",
    "description": "Unwind around a cozy bonfire after sunset. Enjoy live folk music, storytelling, dholki sessions, and local snacks—perfect for family bonding or romantic evenings."
  },
  {
    "title": "Outdoor Activities & Games",
    "description": "From bullock cart rides to traditional games like lagori and gilli‑danda, there’s never a dull moment. Cottages often come with access to swings, rope bridges, and open play areas."
  },
  {
    "title": "Splash Pool & Rain Dance Access",
    "description": "Some home‑stay options include access to nearby agro‑tourism splash zones—ideal for cooling off after farm walks, with slides, kiddie pools, and DJ‑powered rain‑dance sessions."
  },
  {
    "title": "Seasonal Festival Experiences",
    "description": "Time your stay with seasonal events: mango‑fare in summer, hurda‑parties in winter, or cultural days featuring folk dance and craft demonstrations—bringing village culture to life."
  },
  {
    "title": "Birding & Photography Mornings",
    "description": "Early risers can enjoy guided peacock watching tours, birding walks, and misty sunrise photo sessions among farmland—ideal for nature photographers and bird enthusiasts."
  }
],




"services": [
  {
    "name": "Traditional Village Homestays in Morachi Chincholi",
    "description": "Anand Krushi Paryatan Kendra offers authentic village homestays designed to immerse guests in a true Maharashtrian rural lifestyle. From clay-walled rooms and woven charpais to lantern-lit evenings and home-cooked meals, this stay offers an enriching cultural escape surrounded by nature."
  },
  {
    "name": "Farm-Style Stay Near Pune",
    "description": "Just a short drive from Pune, experience a peaceful farm-style stay at Anand Krushi Paryatan Kendra. Wake up to the sound of roosters, explore green farmlands, and unwind in rustic yet clean accommodations designed to reflect traditional living with basic modern comforts."
  },
  {
    "name": "Comfortable Budget Homestays",
    "description": "Perfect for families and groups looking for a pocket-friendly escape, our budget homestays provide clean bedding, attached washrooms, hearty meals, and easy access to all farm activities. Enjoy a fulfilling stay without breaking your budget."
  },
  {
    "name": "Family-Run Home Experiences",
    "description": "Stay with a warm, welcoming host family who’ll treat you like one of their own. Learn how to make bhakris on a chulha, help with evening farm chores, or just chat with locals over tea—all part of our genuine family-run homestay charm."
  },
  {
    "name": "Organic Farm Homestays",
    "description": "Stay right beside our organic farm, where you can see, learn, and even take part in natural farming techniques. These eco-conscious homestays offer a chance to live sustainably, eat fresh organic produce, and reconnect with nature."
  },
  {
    "name": "Nature Homestay for Families",
    "description": "Looking for a weekend with your family in the lap of nature? Our nature homestays are surrounded by mango orchards, peacock habitats, and open skies—perfect for slow mornings, outdoor games, and quiet evenings under the stars."
  },
  {
    "name": "Rural Lifestyle Experience Stay",
    "description": "Live like a local with our rural lifestyle stays. Participate in everyday village routines—fetching water, milking cows, grinding grains—while staying in cozy, traditionally styled homes designed to offer a truly immersive experience."
  },
  {
    "name": "Pet-Friendly Homestay Options",
    "description": "Bring your furry friends along! Anand Krushi Paryatan Kendra offers pet-friendly homestay spaces with open grounds, shaded rest areas, and pet bowls. Enjoy a vacation with your entire family—including the four-legged members."
  },
  {
    "name": "Homestays with Local Food",
    "description": "Savor authentic Maharashtrian meals prepared using fresh farm ingredients. From piping hot poha breakfasts to traditional zunka-bhakri lunches and sweet aamras in season, our homestays let you taste the real flavors of rural Maharashtra."
  },
  {
    "name": "Eco-Friendly Accommodation in Morachi Chincholi",
    "description": "Our eco-stays are built with natural materials like mud, brick, and bamboo. These structures stay cool in summer, warm in winter, and use minimal electricity, offering a responsible way to travel while staying connected to the earth."
  },
  {
    "name": "Cultural Stay Experiences",
    "description": "Stay with local families who are proud to share their traditions—from folk dance evenings and storytelling sessions to participating in local festivals. These cultural homestays offer more than just a bed—they offer belonging."
  },
  {
    "name": "Quiet Countryside Homestays",
    "description": "Escape the chaos of the city with a night or two in our quiet countryside homes. Surrounded by green fields, chirping birds, and open skies, these homes are perfect for writers, couples, or anyone seeking pure peace and digital detox."
  },
  {
    "name": "Home Stays with Farm Tours",
    "description": "Pair your stay with a guided tour of our working farm. Learn how crops are grown, visit the animal shelters, taste fresh produce, and even take part in seasonal farm activities. A stay that teaches as much as it relaxes."
  },
  {
    "name": "Affordable Rural Homes for Night Stay",
    "description": "Looking for a simple overnight getaway? Our rural homes provide clean, comfortable, and budget-friendly night stays ideal for weekenders, students, and group travelers. Enjoy dinner under the stars and a peaceful night’s sleep."
  },
  {
    "name": "Homestays with Local Guides",
    "description": "Gain deeper insights with the help of local guides who can take you on nature walks, explain village customs, or help you spot peacocks at sunrise. These guided stays help you see Morachi Chincholi through local eyes."
  }
],
"tableData": [
  ["Traditional Village Homestays in Morachi Chincholi", "- Farm-Style Stay Near Pune"],
  ["Comfortable Budget Homestays", "- Family-Run Home Experiences"],
  ["Organic Farm Homestays", "- Nature Homestay for Families"],
  ["Rural Lifestyle Experience Stay", "- Pet-Friendly Homestay Options"],
  ["Homestays with Local Food", "- Eco-Friendly Accommodation in Morachi Chincholi"],
  ["Cultural Stay Experiences", "- Quiet Countryside Homestays"],
  ["Home Stays with Farm Tours", "- Affordable Rural Homes for Night Stay"],
  ["Homestays with Local Guides", "- "]
],



"whychoose": [
  {
    "WhyChooseheading": "Peacock Watching in Natural Habitat",
    "WhyChoosedescription": "Morachi Chincholi is famous for its free-roaming peacocks. Early mornings and evenings offer a spectacular sight of peacocks dancing and calling, providing a unique and serene wildlife experience in their natural environment."
  },
  {
    "WhyChooseheading": "Bullock Cart and Tractor Rides",
    "WhyChoosedescription": "Experience rural life with traditional bullock cart rides and tractor tours around the village and farmlands. These activities offer both fun and educational insights into the farming culture of Maharashtra."
  },
  {
    "WhyChooseheading": "Agro-Tourism and Farm Visits",
    "WhyChoosedescription": "Explore organic farms, learn about crop cultivation, and engage in hands-on activities like vegetable picking and animal feeding. Perfect for families, students, and anyone curious about sustainable farming practices."
  },
  {
    "WhyChooseheading": "Adventure and Outdoor Games",
    "WhyChoosedescription": "Enjoy fun activities like zip-lining, rope climbing, archery, and more. Open grounds also allow for traditional outdoor games such as cricket, badminton, and volleyball—great for team bonding and energetic fun."
  },
  {
    "WhyChooseheading": "Cultural Programs and Folk Entertainment",
    "WhyChoosedescription": "Immerse yourself in village culture through folk dances, puppet shows, and music performances. These events highlight the local heritage and provide wholesome entertainment for all age groups."
  },
  {
    "WhyChooseheading": "Seasonal Festivals and Special Events",
    "WhyChoosedescription": "Participate in seasonal events like the Hurda Party in winter and Mango Mahotsav in summer. These festivals celebrate local harvests and offer delicious food, traditional games, and a festive atmosphere unique to rural Maharashtra."
  }
]





















    }

const faqData = [
  {
    id: 'FAQ1',
    question: 'What is the homestay experience like at Morachi Chincholi?',
    answer: 'Homestays at Morachi Chincholi offer rustic, comfortable stays in village-style cottages or farmhouses, providing easy access to peacock sightings, farm activities, and village life.',
  },
  {
    id: 'FAQ2',
    question: 'Where can I book a homestay in Morachi Chincholi?',
    answer: 'Popular options include Anand Krushi Paryatan Kendra and nearby agritourism farms that offer cozy homestays alongside their farm activities.',
  },
  {
    id: 'FAQ3',
    question: 'What amenities are provided in the homestays?',
    answer: 'Most provide basic but clean facilities: comfortable beds, attached or shared bathrooms, local cuisine meals, Wi-Fi (limited), and open courtyard areas.',
  },
  {
    id: 'FAQ4',
    question: 'Are homestays family-friendly?',
    answer: 'Yes, they’re ideal for families. Kids can interact with animals, play outdoor games, and explore nature while parents enjoy peace and cultural immersion.',
  },
  {
    id: 'FAQ5',
    question: 'Do I need to book in advance?',
    answer: 'Advance booking is highly recommended, especially during weekends, holidays, and festival seasons like Hurda or Mango Mahotsav.',
  },
  {
    id: 'FAQ6',
    question: 'What meals are included in a homestay package?',
    answer: 'Homestay packages typically include traditional farm-to-table breakfast, lunch, snacks, and dinner with locally sourced seasonal dishes.',
  },
  {
    id: 'FAQ7',
    question: 'How long can I stay at a homestay?',
    answer: 'You can book for a weekend getaway or extended stays depending on availability—most homestays offer 1–3 night packages.',
  },
  {
    id: 'FAQ8',
    question: 'Are there agricultural experiences included?',
    answer: 'Yes. Many homestays include farm tours, crop harvesting, milking cows, feeding animals, and guided nature walks as part of your stay.',
  },
  {
    id: 'FAQ9',
    question: 'Is it safe and hygienic?',
    answer: 'Yes, reputable homestays adhere to cleanliness standards. They use farm-fresh produce and maintain hygienic lodging and dining areas.',
  },
  {
    id: 'FAQ10',
    question: 'How do I reach a homestay in Morachi Chincholi?',
    answer: 'Morachi Chincholi is about 65 km from Pune via Alandi or Chakan. You can drive, hire a taxi, or arrange pickup through your homestay provider.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Suresh Kulkarni, Pune',
    feedback: "Staying overnight at a Morachi Chincholi homestay was incredible! Waking up to chirping birds and peacocks was magical, and the home-cooked meals were delicious and authentic.",
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Asha More, Mumbai',
    feedback: "We stayed two nights at an agritourism homestay—perfect blend of comfort and rural charm. The farm activities for kids were a big hit, and we left feeling refreshed.",
    rating: 5,
  },
];
























    const carouselItems = testimonials.map(testimonial => (
        <div key={testimonial.name}>
            <blockquote>

                <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
                <footer className=' user'>— {testimonial.name}</footer>
            </blockquote>
        </div>
    ));

    const carouselOptions = {
        loop: true,
        margin: 10,
        nav: true,
        items: 1
    };

    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9689125047",
            "+91 9623755047",
            "+91 9673132497",


        ],
        email: "thopatemala@gmail.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "One Day Picnic Spot Near Pune for Family",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "One Day Trip Near Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Picnic Spot Near Pune ",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Picnic Destination Near Pune ",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Corporate Outing Resorts Near Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Agri Tourism Near Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Destination Wedding Near Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Hurda Party Places Near Pune",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Water Park Near Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "School Picnic Spots Near Pune for Students",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "One Day Adventure Resorts Near Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Resort Near Pune ",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Forest Resorts Near Pune ",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Nature resorts near pune for weekend",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mango Mahotsav in Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Krushi Paryatan Kendra near Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Camping Places Near Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Activities Resort Near Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Agro Tourism Near Mumbai for Family",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "One Day Picnic Spot From Mumbai",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "One Day Picnic Packages Near Mumbai",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "School Picnic Spots in Mumbai",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Resort Near Mumbai ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Team Outing Places Near Mumbai",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Corporate Outing Near Mumbai",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Picnic Spot Near Nashik",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Farm House On Rent in Pune ",
        },
    ];


    const images = [
        { src: "/images/gallery/01.jpg", alt: "Image 1" },
        { src: "/images/gallery/02.jpg", alt: "Image 1" },
        { src: "/images/gallery/03.jpg", alt: "Image 1" },
        { src: "/images/gallery/04.jpg", alt: "Image 1" },
        { src: "/images/gallery/05.jpg", alt: "Image 1" },
        { src: "/images/gallery/06.jpg", alt: "Image 1" },
        { src: "/images/gallery/07.jpg", alt: "Image 1" },
        { src: "/images/gallery/08.jpg", alt: "Image 1" },
        { src: "/images/gallery/09.jpg", alt: "Image 1" },
        { src: "/images/gallery/010.jpg", alt: "Image 1" },
        { src: "/images/gallery/011.jpg", alt: "Image 1" },
        { src: "/images/gallery/012.jpg", alt: "Image 1" },

    ];

const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Morachi Chincholi Home Stay",
  "image": "https://morachichincholi.in/assets/images/morachi-chincholi-home-stay.jpg",
  "description": "Experience traditional village homestays in Morachi Chincholi with farm-style comfort, organic farming stays, family-run hospitality, eco-friendly accommodations, local food, and peaceful rural lifestyle near Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Anand Krushi Paryatan Kendra"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1540"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1200",
    "availability": "https://schema.org/InStock",
    "url": "https://morachichincholi.in/home-stay"
  }
};




    return (
        <div>
<Helmet>
  <title>Morachi Chincholi Home Stay | Traditional Village & Farm-Style Accommodation Near Pune</title>
  <meta 
    name="description" 
    content="Stay at traditional village homestays in Morachi Chincholi offering organic farm stays, family-run hospitality, local cuisine, eco-friendly options, and a peaceful rural experience near Pune." 
  />
  <meta 
    name="keywords" 
    content="Traditional village homestays in Morachi Chincholi, Farm-style stay near Pune, Comfortable budget homestays, Family-run home experiences, Organic farm homestays, Nature homestay for families, Rural lifestyle experience stay, Pet-friendly homestay options, Homestays with local food, Eco-friendly accommodation in Morachi Chincholi, Cultural stay experiences, Quiet countryside homestays, Home stays with farm tours, Affordable rural homes for night stay, Homestays with local guides" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="breadcrumb-main pb-20 pt-14" style={{ backgroundImage: 'url(images/bg/bg1.jpg)' }}>
                <div className="section-shape section-shape1 top-inherit bottom-0" style={{ backgroundImage: 'url(images/shape8.png)' }}></div>
                <div className="breadcrumb-outer">
                    <div className="container">
                        <div className="breadcrumb-content text-center">
                            <h1 className="mb-3"> {cardData.keyword}</h1>

                        </div>
                    </div>
                </div>
                <div className="dot-overlay"></div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/24.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#609F31', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 darkcolor'> Why Choose Anand Krushi Paryatan Kendra for {cardData.keyword + " Rates"}</h3>
                            {/* <BusRatesTable /> */}

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 darkcolor"> {item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">fAQS {cardData.keyword} For Anand Krushi Paryatan Kendra</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                {faqData.map((faq) => (
                                                    <FAQItemm key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <div>

                                <div className="contact-box Borderr">
                                    <h3 className='darkcolor'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Gallery</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image py-1"

                                            />
                                        </div>
                                    ))}
                                    {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #609F31',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#609F31' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2 text-white"></i>
                                            <div className=''>
                                                <a href="tel:+919689125047" className="d-block  text-white">+91 9689125047</a>
                                                <a href="tel:+919623755047" className="d-block  text-white">+91 9623755047</a>
                                                <a href="tel:+919673132497" className="d-block  text-white">+91 9673132497</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <i className="bi bi-envelope fs-1 mb-2 text-white"></i>
                                                <a href="mailto:thopatemala@gmail.com" className=" text-white d-block">
                                                    thopatemala@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <i className="bi bi-house-fill fs-1 mb-2 text-white"></i>
                                                <p className="whit text-white ">
                                                    <i> Anand Krushi Paryatan Kendra <br />
                                                        Dattatraya Anandrao Thopate, Topate Vasti, Chincholi Morachi, Tal. Shirur, Dist. Pune. Maharashtra - 412218

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Morachichincholihomestay;